import { render, staticRenderFns } from "./applyBai1.vue?vue&type=template&id=9ae5fa68&scoped=true&"
import script from "./applyBai1.vue?vue&type=script&lang=js&"
export * from "./applyBai1.vue?vue&type=script&lang=js&"
import style0 from "./applyBai1.vue?vue&type=style&index=0&id=9ae5fa68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae5fa68",
  null
  
)

export default component.exports